// nodes/conditionalNode.js
import { BaseNode } from "../baseNode";
import { nodeConfigs } from "../nodeConfigs";
export const ConditionalNode = ({ id, data }) => (
  <BaseNode id={id} data={data} config={nodeConfigs.conditional} />
);
